



























































export default

	props:
		product: Object
		loadingEcomm: Boolean
		useQuickShop: Boolean
		tag: # tag as prop. Use 'li' where appropriate.
			type: String
			default: 'div'

	computed:

		# Make product url
		url: -> '/' + @product.uri

		badge: -> switch

			# Only show badges on sites that sell THC products
			when process.env.CMS_SITE in ['cbd', 'hemp'] then return

			# Use custom badge, if specified
			when @product.customBadge then @product.customBadge

			# Check for product availability
			when @product.productAvailability?[0]?.title == 'California'
			then 'california'
			when @product.productAvailability?[0]?.title == 'National'
			then 'nationwide'

		badgeClasses: -> "badge-#{@badge}"

		# Make optional variants easier to use
		variants: -> @product.variants || []

		# Find the lowest price in all of the variants
		lowestPrice: -> @variants.reduce (lowestPrice, variant) ->
			variantPrice = parseFloat variant.price?.amount || 0
			if lowestPrice
			then Math.min lowestPrice, variantPrice
			else variantPrice
		, 0

		# Make the variant count message
		variantCountMessage: ->
			"#{@variants.length} Options" if @variants.length > 1

		# Should the "Quick Shop" button be shown
		showQuickShop: -> @useQuickShop and !@outOfStock

		# Should the "Notify Me" button be shown (currently only supported on
		# Shopify)
		showNotifyMe: ->
			process.env.SHOPIFY_CART_ENABLED and
			@useQuickShop and @outOfStock

		# Check that the key is defined on the product and if it's true or false
		outOfStock: -> @product.availableForSale? and !@product?.availableForSale

	methods:

		openQuickShop: (clickEvent) ->
			QuickShopModal = (await import('./quick-shop-modal')).default
			await @$mountOnBody QuickShopModal,
				parent: this
				propsData: { @product }
			@$emit 'open-quick-shop', clickEvent

		openNotifyModal: (clickEvent) ->
			NotifyModal = (await import('./notify-modal')).default
			await @$mountOnBody NotifyModal,
				parent: this
				propsData: { @product }


